export default "__VITE_ASSET__CNkwSGR___"